import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const SectionHeader = ({ children, className }) => (
  <h2 className={classNames('courses-gift-card-overview__section-header', className)}>{children}</h2>
);

export default SectionHeader;
